// SuccessAlert.js
import React from 'react';
import './addToCartSuccess.css';

const SuccessAlert = ({ message }) => {
  return (
    <div className='success-container'>
      <span className='success-message'>{message}</span>

    </div>
  );
};



export default SuccessAlert;
